export default {
    name: "HYP Loyalty",
    description:
        "We offer path-breaking reward and engagement management solutions to companies for acquisition, retention and enhancement of their relationships with consumers, channel and trade partners, trade influencers and employees. We support you with the creation and efficient management of your trade/reward programs & we ensure to offer the right fit for the industry to indulge, incentivise and involve the consumer or the partner for a mutual growth that keeps them loyal, engaged & asking for more.",
    author: "HYP-Loyalty",
    titleSeparator: "|",
};
